
	import { ChangeDetectorRef, Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormsService } from '../../services/forms.service';
import * as jwt_decode from 'jwt-decode';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {SelectionModel} from '@angular/cdk/collections';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../../../../middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormAuditType, ProjectTempStep, ProjectTempType, RoleLevel } from '../../services/form.enum';
import { ToastrService } from 'ngx-toastr';
import { Clipboard } from "@angular/cdk/clipboard"
@Component({
  selector: 'app-draft',
  templateUrl: './draft.component.html',
  styleUrls: ['./draft.component.scss']
})
export class DraftComponent implements OnInit {

  databaseId: string;
  organizationId: string;
  currentUser: any;
  draftedProjectsList: any[] = [];  
  fileItemsList:any[] = [];  
  displayedColumns: string[] = [];
  dataSource: any;
  selection = new SelectionModel<any>(true, []);
  _returnList: any[] = [];
  _returnColumns: any[] = [];
  Module:string;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength: any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  SelectedRecordForDeleFav:boolean=false;
  selectedRecordDeleteArray: any = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  docDetail:boolean = false;
  showmyDrive:boolean = false;
  noRecordFound:boolean = false;
  pageIndex: any;
  pageSize: any;
  value = '';
  OfficeIDList: any=[];
  myOfficeID: any;
  currentData: PageEvent;
  rolesAsssign: any[] = [];
  ShowMasterTemplate:boolean=false;
  
  constructor(private toastr: ToastrService,private clipboard: Clipboard,private router: Router,private dialog: MatDialog,private formsService:FormsService,
    private reusableClass:ReusableClasses,private encryptionAlgo: EncryptionService,
    private _dataSharingService: DataSharingService, private cdr: ChangeDetectorRef,
    private loaderService: LoaderService) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);      
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
     }

    ngAfterContentChecked() {
     this.cdr.detectChanges();
    }

   ngOnInit(): void {
     sessionStorage.setItem('edashboard', "false");
     this.getDraftedProjects(this.pageModelData);
     this.setDisplayedColumns();
     
     this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
     if(this.rolesAsssign.length > 0){
       var role=[];
       // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
       role= this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin);
       if(role.length > 0){
        this.ShowMasterTemplate = true;
       }else{
         this.ShowMasterTemplate = false;
       }
     }
   }

   CreatePdfForm(Option){   
    // True-Create PDF Form
    // False-Create Master Template PDF Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplatePDFForm','true');
      sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    }else{
      sessionStorage.setItem('MasterTemplatePDFForm','false');
      sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
    sessionStorage.removeItem('categoryID'); 
    sessionStorage.removeItem('stepCompleted');
    this._dataSharingService.sendSelectedProjectName("");
    this.router.navigate(['/esignature/first']);
  }
  
  CreateHTMLForm(Option){      
    if(Option==false){
      sessionStorage.setItem('MasterGlobalTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');     
    }else{
      sessionStorage.setItem('MasterTemplateWebForm','true');
      sessionStorage.setItem('MasterOrgTemplateWebForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");   
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    this._dataSharingService.sendSelectedModuleName('Forms');
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/htmlform']);
  }
  
   CreateAuditForm(Option){    
    // True-Create Tabular Form
    // False-Create Master Template Tabular Form
    if(Option==false){
      sessionStorage.setItem('MasterTemplateTabularForm','true');
    }else{
      sessionStorage.setItem('MasterTemplateTabularForm','false');
    }
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    sessionStorage.setItem('type',(ProjectTempType.Template).toString());
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.removeItem('stepCompleted');
    sessionStorage.removeItem('categoryID');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');   
    this._dataSharingService.sendSelectedProjectName("");
    sessionStorage.setItem('isSharedWithMeForm','false');
    this.router.navigate(['/esignature/firsttabular']);
  }
  
  OpenProjectDeatils(project){   
    sessionStorage.setItem('ProjectName',project.projectName);
    sessionStorage.setItem('projectID',project.projectID);
    sessionStorage.setItem('stepCompleted',project.stepCompleted);
    sessionStorage.setItem('type',(ProjectTempType.Project).toString());
    sessionStorage.setItem('ImportTemplateShow','true');
    sessionStorage.setItem('MasterTemplatePDFForm','false');
    sessionStorage.setItem('MasterTemplateTabularForm','false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm','false');
    sessionStorage.setItem('FolderOpenId','0');
    sessionStorage.setItem('FolderOpenName','');    
    if(project.stepCompleted == ProjectTempStep.Step0) {
      this.router.navigate(['/esignature/first']);
    }
   else if(project.stepCompleted == ProjectTempStep.Step1) {
      this.router.navigate(['/esignature/second']);
    }
    else if(project.stepCompleted == ProjectTempStep.Step2) {
      this.router.navigate(['/esignature/third']);
    }
    else if(project.stepCompleted == ProjectTempStep.Step3 || project.stepCompleted == ProjectTempStep.Step4) {
      this.router.navigate(['/esignature/four']);
    }
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);   
  }

   editProject(draft: any) {
     let storedProjects = localStorage.getItem('FinalSaveAndCloseProjectIDs');
    let projectArray = storedProjects ? JSON.parse(storedProjects) : [];
    let isAlreadyExist = projectArray.includes(draft.projectID);
    localStorage.setItem('isDisableTabularForm', isAlreadyExist ? 'true' : 'false');
    this.dialog.closeAll();
    sessionStorage.setItem('projectID', draft.projectID);
    sessionStorage.setItem('type', (ProjectTempType.Project).toString()); // 1 for Project and 2 for Template
    sessionStorage.setItem('ImportTemplateShow', 'true');
    sessionStorage.setItem('MasterTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateTabularForm', 'false');
    sessionStorage.setItem('MasterOrgTemplatePDFForm', 'false');
    sessionStorage.setItem('MasterTemplateWebForm', 'false');
    this._dataSharingService.sendSelectedProjectName("");
    // this.router.navigate(['/esignature/second']);
    let links = window.location.href.split(window.location.pathname)[0] + "/esignature/secondtabular"
    window.open(links, "_blank");
    sessionStorage.setItem('HeaderModuleName', 'Forms');
    this._dataSharingService.sendSelectedModuleName('Forms');
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }


  OpenTablarDeatils(project){
    if(project.token!=null){
      let formSigningLink= window.location.href.split(window.location.pathname)[0]+"/request/tabularsignature?token="+project.token;
      window.open(formSigningLink, "_blank"); 
    }    
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => 
          {
          this.selection.select(row)});
          this.selectedRecordDeleteArray=[];    
        
          if (this.selection.selected.length > 0) {
            for (let i = 0; i < this.selection.selected.length; i++) {          
                let ReqModel = {
                  selectedRecord: this.selection.selected[i].projectID
                  };
                 this.selectedRecordDeleteArray.push(ReqModel);    
            }
            this.SelectedRecordForDeleFav = true;
          }
          else {
            this.SelectedRecordForDeleFav = false;
            this.selectedRecordDeleteArray = [];
          }     
  }

  isAllSelectedRow(event, element) {
      let ReqModel = {
        selectedRecord: element.projectID
      };
      if (event.checked) {
        this.selectedRecordDeleteArray.push(ReqModel);
      } else {
        let removeIndex = this.selectedRecordDeleteArray.findIndex(
          (itm) => itm.selectedRecord === element.projectID
        );
        if (removeIndex !== -1) this.selectedRecordDeleteArray.splice(removeIndex, 1);
      }
  
      if (this.selectedRecordDeleteArray.length > 0) {
        this.SelectedRecordForDeleFav = true;
      }
      else {
        this.SelectedRecordForDeleFav = false;
        this.selectedRecordDeleteArray = [];
      }   
  }

  deleteDraftProjects(){
    const message = `Are you sure you want to delete selected record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let selectedProjectIds=[];
          this.selectedRecordDeleteArray.forEach(element => {
            selectedProjectIds.push(element.selectedRecord);
          });
          let rqModel = {
            projectId: selectedProjectIds,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          }
          this.formsService.deleteDraftedProjects(rqModel).subscribe(response=>{
            if(response.data==true){
              this.SelectedRecordForDeleFav = false;
              this.pageModelData.searchValue="";
              this.getDraftedProjects(this.pageModelData);
            }
          })
         
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.selection.selected.forEach(item => {
            let index: number = this.dataSource.data.findIndex(d => d === item);  
            this.dataSource.data.splice(index, 1)
            this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
          });
          this.selection = new SelectionModel<Element>(true, []);
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });     
  }

  deleteDraftedProject(projectId){
    const message = `Are you sure you want to delete selected record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;    
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let rqModel = {
            projectId: [projectId],
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          }
          this.formsService.deleteDraftedProjects(rqModel).subscribe(response=>{
            if(response.data==true){
              this.SelectedRecordForDeleFav = false;
              this.pageModelData.searchValue="";
              this.getDraftedProjects(this.pageModelData);
            }
          })
         
          this.SelectedRecordForDeleFav = false;
          this.selectedRecordDeleteArray = [];
          this.selection.selected.forEach(item => {
            let index: number = this.dataSource.data.findIndex(d => d === item);  
            this.dataSource.data.splice(index, 1)
            this.dataSource = new MatTableDataSource<Element>(this.dataSource.data);
          });
          this.selection = new SelectionModel<Element>(true, []);
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });  
   
  }
  viewProjectDetails(draft: any) {
    this.loaderService.show();
  let reqModel = {
    projectId: draft.projectID,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),
    projectStatus: draft.projectStatus || 0,  
    officeID: draft.officeID || 0              
  };

  this.formsService.getFileItemsByProjectId(reqModel).subscribe({
    next: (response) => {
       this.loaderService.hide();
      if (response && response.data) {
        this.fileItemsList =response.data;
        this.docDetail = true;
      }
    },
    error: (err) => {
      this.loaderService.hide();
      //console.error("Error fetching project details:", err);
    }
  });
}

copyProjectUrl(draft: any) {
  if (draft.token !=null) {
    let formSigningLink= window.location.href.split(window.location.pathname)[0]+"/request/tabularsignature?token="+draft.token;
    this.clipboard.copy(formSigningLink);
    // Show success toast
    this.toastr.success("Link Copied.", '', {
      timeOut: 3000,
    });
  }
}

  setDisplayedColumns() {
    this.displayedColumns  = ['projectId','projectType','projectName', 'stepCompleted','createdOn', 'updatedOn', 'action'];
  }

  
  pageEventPropogate(pageData: PageEvent) {
    this.currentData = pageData; 
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.searchValue;
    this.getDraftedProjects(this.pageModelData);       
  }

  SearchFilter() { 
    this.selection.clear(); 
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue; 
    if(this.pageModelData.searchValue==""){
     return;
    }
    this.getDraftedProjects(this.pageModelData);
  }

  ValidateDate(updatedDate:any):string {
    if((updatedDate!=null )&& (updatedDate!=undefined)){
      var year = new Date(updatedDate).getFullYear();
      if(year>1)
      return updatedDate;
      else
      return "";  
    }
    else {
      return "";
    }   
  }

  Search(filterValue) {   
    this.selection.clear();
    this.SelectedRecordForDeleFav=false;
    this.pageModelData.pageIndex=0;
    this.pageModelData.searchValue=filterValue;
    this.getDraftedProjects(this.pageModelData);
  }
  

  getDraftedProjects(pageData: any) {
    var ReqModel = {
      projectStatus: 1,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      searchKey:this.pageModelData.searchValue,
      pageIndex:pageData.pageIndex,
      pageSize:pageData.pageSize,
      OfficeIDList:this.OfficeIDList,
      officeID:this.myOfficeID
    }
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.loaderService.show();
    this.formsService.getDraftedProjects(ReqModel).subscribe(response=>{
     if(response.data!=null){
       this.dataSource = new MatTableDataSource<any>();
       this.draftedProjectsList = response.data.projects;
       this.dataSource.data =this.draftedProjectsList;     
       this.dataSource.sort = this.sort;
       this.paginatorTotalLength = response.data.totalcount;
       this.pageModelData.pageIndex = response.data.pageIndex;
       this.pageIndex = response.data.pageIndex;
       this.pageSize = pageData.pageSize;
       if(this.draftedProjectsList.length > 0){
        this.noRecordFound=false;
      }else{
       this.noRecordFound=true;
       this.SelectedRecordForDeleFav=false;
       this.selection.clear();
      }
      this.loaderService.hide();
     }else{
       this.paginatorTotalLength=0;
       this.loaderService.hide();      
     }
    });
  }
 
  // showDocDetail() {
  //   this.docDetail = !this.docDetail
  // }
  
  showMyDrive() {
    this.showmyDrive = !this.showmyDrive
  }

  close() {
    this.dialog.closeAll();
  }
  
  
}
